import React from 'react';
import classNames from 'classnames';
import ActionButton from '../action-button';

const ButtonsHeader = ({
  isSticky = true,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: string; onClick?: (...args: any[]) => any; iconGlyph?: string; disabled?: boolean; }'.
  prevButton = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '{ label?: string; onClick?: (...args: any[]) => any; iconGlyph?: string; disabled?: boolean; }'.
  nextButton = null,
}) => (
  <div
    className={classNames('ws-ui-buttons-header', {
      'ws-ui-buttons-header--sticky': isSticky,
    })}
  >
    <div className="ws-ui-buttons-header__container">
      <div className="ws-ui-buttons-header__button-wrapper">
        {prevButton && (
          <ActionButton
            format="text"
            // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'nu... Remove this comment to see the full error message
            iconGlyph={prevButton.iconGlyph || null}
            onClick={prevButton.onClick}
            // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            label={prevButton.label}
            disabled={prevButton.disabled}
          />
        )}
      </div>

      <div className="ws-ui-buttons-header__button-wrapper">
        {nextButton && (
          <ActionButton
            format="text"
            // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'nu... Remove this comment to see the full error message
            iconGlyph={nextButton.iconGlyph || null}
            iconPlacement="after"
            onClick={nextButton.onClick}
            // @ts-ignore TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            label={nextButton.label}
            disabled={nextButton.disabled}
          />
        )}
      </div>
    </div>
  </div>
);

export default ButtonsHeader;
